<template>
  <div class="audit">
    <span class="audit__label">{{
      `${$t("message.analytics.auditMade")}:`
    }}</span>
    <p class="audit__date">{{ date }}</p>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AuditDate",
  props: {
    auditDate: {
      type: String,
      required: true
    }
  },
  computed: {
    date() {
      return moment(this.auditDate).format("DD.MM.YYYY HH:MM");
    }
  }
};
</script>

<style lang="scss" scoped>
.audit {
  text-align: right;

  &__date {
    color: $gray;
    font-size: 14px;
    margin: 0;
  }
}
</style>
